// extracted by mini-css-extract-plugin
export default {"container":"LogoExample_container__P9J9H","title":"LogoExample_title__vHFeQ","section":"LogoExample_section__xU23S","darkSection":"LogoExample_darkSection__V0OUU"};